import React from 'react';

export const PlasticChainType = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="#fff"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <g fill="#010101">
        <path d="M22.2 71.5l-1.7 2.2-1.2-.9 4.8-6.3 2.1 1.6c.4.3.8.6 1 1 .2.3.4.7.5 1 .1.3.1.7 0 1-.1.3-.2.6-.5.9-.2.3-.5.6-.8.7-.3.2-.6.3-1 .3-.3 0-.7 0-1.1-.2-.4-.1-.8-.4-1.2-.7l-.9-.6zm.7-.9l.9.7c.2.2.4.3.6.3.2.1.4.1.6.1s.4-.1.5-.2c.2-.1.3-.2.4-.4.1-.2.2-.3.3-.5.1-.2.1-.4 0-.5 0-.2-.1-.3-.2-.5s-.3-.3-.5-.5l-.9-.7-1.7 2.2zM28.6 77.4l2.9 1.3-.5 1.1-4.2-1.9 3.3-7.2 1.3.6-2.8 6.1zM40.9 82.2l-1.1-.2c-.1 0-.2-.1-.3-.2-.1-.1-.1-.2-.1-.3l-.3-1.7-3.2-.6-.9 1.5c0 .1-.1.1-.2.2s-.2.1-.3 0l-1.1-.2 4.6-7.2 1.5.3 1.4 8.4zm-4.5-4l2.5.5-.4-2.8c0-.1 0-.3-.1-.4 0-.2 0-.3-.1-.5-.1.2-.2.3-.2.5-.1.1-.2.3-.2.4l-1.5 2.3zM47.9 75.5c0 .1-.1.1-.1.2s-.1.1-.2.1-.2 0-.3-.1-.2-.1-.3-.2c-.1-.1-.3-.1-.4-.2-.2-.1-.4-.1-.6-.1-.2 0-.4 0-.5.1-.1.1-.3.1-.4.2-.1.1-.2.2-.2.3 0 .1-.1.3-.1.4 0 .2.1.3.2.5.1.1.3.2.4.3s.4.2.6.2c.2.1.5.1.7.2s.5.2.7.2.4.2.6.4c.2.2.3.3.4.6.1.2.2.5.2.8 0 .4 0 .7-.1 1s-.3.6-.5.8c-.2.2-.5.4-.8.6-.3.1-.7.2-1.2.3h-.8c-.2 0-.5-.1-.7-.2l-.6-.3c-.2-.1-.4-.3-.5-.4l.4-.7c0-.1.1-.1.1-.1.1 0 .1-.1.2-.1s.2 0 .3.1c.1.1.2.1.4.2.1.1.3.2.5.2s.4.2.7.2c.4 0 .7-.1 1-.3.2-.2.3-.5.3-.9 0-.2-.1-.4-.2-.5s-.3-.2-.4-.3c-.2-.1-.4-.1-.6-.2s-.4-.1-.7-.2c-.2-.1-.5-.1-.7-.2-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6s-.2-.5-.2-.9c0-.3 0-.6.1-.9.1-.3.3-.5.5-.8.2-.2.5-.4.8-.5s.7-.2 1.1-.2c.5 0 .9 0 1.3.2.4.1.7.3 1 .6l-.4.6zM55.3 72.3l.3 1.2-2.3.6 1.8 6.5-1.5.4-1.8-6.5-2.3.6-.3-1.2 6.1-1.6zM61.5 78.1l-1.3.6-3.4-7.2 1.3-.6 3.4 7.2zM68.1 71.5c.1 0 .1-.1.2-.1l.8.2c0 .5-.2 1-.4 1.4-.2.5-.6.9-1.2 1.3-.5.4-1 .6-1.5.7s-1 .1-1.5 0-.9-.3-1.4-.6c-.4-.3-.8-.7-1.2-1.1-.4-.5-.6-1-.7-1.5-.1-.5-.2-1-.1-1.5s.2-1 .5-1.4c.3-.5.7-.9 1.1-1.2.5-.4.9-.6 1.4-.7.5-.1.9-.1 1.4-.1v1c0 .1-.1.1-.1.2-.1.1-.2.1-.3.1h-.4c-.2 0-.3.1-.5.1-.2.1-.4.2-.7.4-.3.2-.5.5-.7.8-.2.3-.3.6-.3.9 0 .3 0 .7.1 1 .1.4.3.7.5 1 .3.4.6.6.9.8.3.2.6.3.9.4.3.1.6.1.9 0s.6-.2.9-.4c.2-.1.3-.2.4-.4s.2-.2.3-.4c.1-.1.1-.2.2-.4.1-.1.1-.3.1-.4v-.1c.3.1.3 0 .4 0z" />
      </g>
      <defs>
        <circle id="prefix__a" cx={44.2} cy={38.5} r={26.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__b)">
        <path
          fill="none"
          stroke="#1e1e1e"
          strokeWidth={1.75}
          strokeMiterlimit={10}
          d="M50.9.1v66.6"
        />
        <defs>
          <circle id="prefix__c" cx={50.9} cy={4.6} r={2.9} />
        </defs>
        <clipPath id="prefix__d">
          <use xlinkHref="#prefix__c" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__d)">
          <defs>
            <path id="prefix__e" d="M43-3.3h15.7v15.7H43z" />
          </defs>
          <clipPath id="prefix__f">
            <use xlinkHref="#prefix__e" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__f)">
            <image
              width={33}
              height={34}
              xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG8AAACFQAAAzb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAIwMBIgACEQEDEQH/ xACQAAACAwEAAAAAAAAAAAAAAAAABwMFBgQBAQAAAAAAAAAAAAAAAAAAAAAQAAEEAQMFAQAAAAAA AAAAAAUCAwQGABAUFTABEhMHFhEAAgEBBQQGCAcAAAAAAAAAAQIREgAhAwQUEDFRE0FhIiM0FfBx gZGhMlIFQmJykjNTRBIBAAAAAAAAAAAAAAAAAAAAMP/aAAwDAQACEQMRAAAA2K5hz5dbdXRj/MQG Il1a9LmmLU7RoB3KUCkbgFyAf//aAAgBAgABBQDo/wD/2gAIAQMAAQUA6P8A/9oACAEBAAEFADBm AFiEPox6Q7HvFnj96veI5pzL4XcIHWYz7/d6M8xiFqQv9rL21jbW3YK4WSMmHCUea5ngvh/oVYee XpXgEs7O4YZpatrvB2399V8eJz//2gAIAQICBj8AH//aAAgBAwIGPwAf/9oACAEBAQY/ADm865CT CIsF3b6UUkTYnJFMlg/hRVXFaPzNiKR7gLCM6cRZLFcVEeZ6KitUeo2GTzaLlc8R2IPd4p6aJvB6 r9mLlw05bInk4SiYrH8rG831XeoC0YSFo4W7xabK6Eq6kFWFxBF4ItqYWnyrVRH+rUaSf01dFvuS uIJzWM3sZ2YfA25mIquhBEMJE2L4agEncNlMGfKKo6vNKp91j98ySVlVAzqLe0IIXFA6lubgADxO 1cvggrgKQcxmIJXDW8/uMdkW8OvhtDvPhv6t+747MafLOfXfo9TXEH5o7ieMXz7bDUcii+dTz6Nx 36Xt+nCyUaKmo0+XVcmIWKuZ2q/qm/js/9k="
              transform="matrix(.48 0 0 .48 42.89 -3.716)"
              overflow="visible"
            />
          </g>
        </g>
        <defs>
          <circle id="prefix__g" cx={50.9} cy={12} r={2.9} />
        </defs>
        <clipPath id="prefix__h">
          <use xlinkHref="#prefix__g" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__h)">
          <defs>
            <path id="prefix__i" d="M43 4.2h15.7v15.7H43z" />
          </defs>
          <clipPath id="prefix__j">
            <use xlinkHref="#prefix__i" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__j)">
            <image
              width={33}
              height={34}
              xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG3AAACEgAAAzP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACYAIwMBIgACEQEDEQH/ xACMAAADAQEAAAAAAAAAAAAAAAAABQYHBAEBAAAAAAAAAAAAAAAAAAAAABAAAgEEAQMFAAAAAAAA AAAAAwUEAAIGBwEwFRYQERITFBEAAQMABggFBAMAAAAAAAAAARECAwAhEhMEFBAxQWFxgSIVUaEy IwXwkcGSUnJjEgEAAAAAAAAAAAAAAAAAAAAw/9oADAMBAAIRAxEAAAC1zzknCitsmDfSQDP+ikgh 2kGIxNJBrnwCzQAGgB//2gAIAQIAAQUA6P8A/9oACAEDAAEFAOj/AP/aAAgBAQABBQBm0hKYbLZT UxI+wsmDfjGZw3vNZ+3JPeDAUtECUVBKUBfOL/oyK261/jLMK+Y+nRJRK+F/Z9iY4bk3ojSTHc3x xV7U3ja2PKjLNfWc4/2H8Nf/2gAIAQICBj8AH//aAAgBAwIGPwAf/9oACAEBAQY/AH43GyXcLKht c9x1MYNpP1VQj46KPCwg1OeLyQ8V6QvDnQOkmjxDQSSySJoBUIntBh86ZWRuWx4at0SrZEHUYju1 2TWnih0SYRr1wuB9qNoVLxBekrtDunlQ3bS5NaU9xpbxoyaFxjljcHse0oWuaVBFMxcssdszu/M3 2Vu/V6LfPnVT5IOCHNTHkZHEUtYhgkjI1Oo50IDQdg2aLKFe0Wk3d0tL9qH53CtL2PAGMaK7FgBr JOCBD4c9LcJhW1BDNKfTGz+TvwKWbopk+3otVwtr9lrXQ+1izhZQevJh5jJ3JFIz9aE4r5iebwDI ZIxz9l586DsN1ldt2tpf9LfWv9tH/9k="
              transform="matrix(.48 0 0 .48 42.89 3.964)"
              overflow="visible"
            />
          </g>
        </g>
        <defs>
          <circle id="prefix__k" cx={50.8} cy={19.5} r={2.9} />
        </defs>
        <clipPath id="prefix__l">
          <use xlinkHref="#prefix__k" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__l)">
          <defs>
            <path id="prefix__m" d="M42.9 11.6h15.7v15.7H42.9z" />
          </defs>
          <clipPath id="prefix__n">
            <use xlinkHref="#prefix__m" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__n)">
            <image
              width={33}
              height={34}
              xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG9AAACFQAAA0L/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAIwMBIgACEQEDEQH/ xACRAAACAwADAQAAAAAAAAAAAAAABgMFBwECBAgBAQAAAAAAAAAAAAAAAAAAAAAQAAEEAgEEAwAA AAAAAAAAAAQCAwUGABQBEDAxFRM0FhEAAQMBBQYFAQkBAAAAAAAAARECAxIAITEEFBBBEzMFFVFh gSIyYnGRQlKCkiNTY0QSAQAAAAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAGnMeawnec+859AG fAqdXzMizqxhJjUwmRgKHUQJgD//2gAIAQIAAQUA7P8A/9oACAEDAAEFAOz/AP/aAAgBAQABBQCx WISviSFysR7rNhnWOapfVHP5c5Fw+xCR5JnJQT4vPjP1p+pZ2HGLDByy4sqWlUnrzSI9Zeqm7JpU lSFZVamVOk6gvS462+D635hPqZ//2gAIAQICBj8AH//aAAgBAwIGPwAf/9oACAEBAQY/ABPODLNK SIIAUMhCLehQBbzYyHOPy7fwxZZxia0fpNR9TYGLqOZCEuQyvLVcanEtcSCpK2j6d1cNbmZCGw5l opbI43Bj2i4OJwIu3IN9s4XKGZZ5y0bSVQQmgp9rld62IgbURutTKEOzVVuTs1dK/wDVqtFxsMV9 1upMlCOOYkkA+mRxkafVrhbjNwIQg4WLgEXZwKf5OycdP8+4ahf2X2HVentqzcLKZoAL5WNvBamL 2+G8XDAAljwWuaSHNIQgjEEbGyStdF02MrLMQlaHlx+JO87vuB5MfL4Pwbyv68Pj5YbH6js9NITU 6jV/ELXpfcn5bDgdjrUJqO4UL56n2JaDl8tnJ5XxHL+nw8tn/9k="
              transform="matrix(.48 0 0 .48 42.89 11.164)"
              overflow="visible"
            />
          </g>
        </g>
        <g>
          <defs>
            <circle id="prefix__o" cx={50.8} cy={27} r={2.9} />
          </defs>
          <clipPath id="prefix__p">
            <use xlinkHref="#prefix__o" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__p)">
            <defs>
              <path id="prefix__q" d="M42.9 19.1h15.7v15.7H42.9z" />
            </defs>
            <clipPath id="prefix__r">
              <use xlinkHref="#prefix__q" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__r)">
              <image
                width={33}
                height={34}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHAAAACGQAAAzb/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAIwMBIgACEQEDEQH/ xACUAAADAQADAAAAAAAAAAAAAAAABgcFAQMEAQEAAAAAAAAAAAAAAAAAAAAAEAACAQMCBgMAAAAA AAAAAAADBQQAAgYTBxAwEhQVFgERMxEAAQICBggDBgcAAAAAAAAAAQIDABEhMRITBBQQUWFxgSIy FUGRBfCxUnIzNPFCkiNDJEQSAQAAAAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAHWe+JcGZ1kn JfBRCfd7GiGzjGgaRSw98WAzq2AxgH//2gAIAQIAAQUA5P8A/9oACAEDAAEFAOT/AP/aAAgBAQAB BQBkzhKojLctoa8G4uRjJjWZQXvDPXJGDsYSkogiDqOc0Y/u12hkVvza/wAbYghS3cyJJJXRf4fc THZHc8EiWY7nevraP+L7Q72z668K0vGV/9oACAECAgY/AB//2gAIAQMCBj8AH//aAAgBAQEGPwBW MxzoaZSQJ1lSjUlKRST7VQU+nMt4VqdCli8cI48o8uMBbi2n0CttbYAPFFkxl1jLY8Am4JmFhIpU 2qQnur9+hzCpV/WwJLTaR4rH1FHbao3CORJVujnSUw3iGFFDzSgtCxWFJMxF/dt3fa89On7m+y11 X026NcepgiRzb54FxREE4lAcbINBgqYAAJoA0WZGfaLUtndLU/KD65hkFxpaUpxYEyUKQLIc+WyA Px0owmFSZTm66QbDaPiUfdrjoV9l23q/zfDv2w509KvqdFX5tmuFXWStU3nb765tTNV9y/o5YFqU p02py42aYXc5G7tcuQvdX82Y/ctfN4aP/9k="
                transform="matrix(.48 0 0 .48 42.89 18.844)"
                overflow="visible"
              />
            </g>
          </g>
        </g>
        <g>
          <defs>
            <circle id="prefix__s" cx={50.8} cy={34.4} r={2.9} />
          </defs>
          <clipPath id="prefix__t">
            <use xlinkHref="#prefix__s" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__t)">
            <defs>
              <path id="prefix__u" d="M42.9 26.6h15.7v15.7H42.9z" />
            </defs>
            <clipPath id="prefix__v">
              <use xlinkHref="#prefix__u" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__v)">
              <image
                width={33}
                height={33}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG3AAACEAAAA0H/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAIwMBIgACEQEDEQH/ xACNAAACAwEBAAAAAAAAAAAAAAAABwMFBgQBAQEAAAAAAAAAAAAAAAAAAAAAEAABBAMAAgMAAAAA AAAAAAAEAQMFBgACFDAVEDQWEQACAAIHBwIDCQAAAAAAAAABAhEDACExEhMEFBBBUTIzBRWBI2Ei YvBxkaFSklNjRBIBAAAAAAAAAAAAAAAAAAAAMP/aAAwDAQACEQMRAAAA1Kz9qjq269gH+L8MmblZ lrUl+dA0wmwoFA0wJgD/2gAIAQIAAQUA8P8A/9oACAEDAAEFAPD/AP/aAAgBAQABBQCxWISAEkbn YZBxqy2BlyqXxT3susk7IWEQAkxSgnxdkVdV/WH8lnYcYsMDMbxJcxLaH75xEesvlUekkVF1XKtV ip0rkF+Lny9wXrOgT6mf/9oACAECAgY/AB//2gAIAQMCBj8AH//aAAgBAQEGPwBZ89TNmzCVkSFM C5FtdcAI1mhbVvlpYJKSsuTKCg7ryQZvU0WYncsyWUxAea7rVxVyyn1FJXbe7ALmphuysyogsxjy qyixjxFX3bM1ePt5VjlpS/pEolW3C14n8qESFvEbhS7NWBoCDAisEWxpqcVrvhb8I/6tTo8bltjX 9o07kk0QY5iZMA+mYxmKfVWFMZYEEQIIiKMwWBJ2YF33PCY8P6/IaiP7K6L3TtyX83KW5PkqBGZL WJDLxcWQ3iyysgiBFRBtjsV3RpfbZbe/PsjCu4kbSbKrLTuB6Mvp4PIvS/js5fhZsbU+IuwWGo1G ssHPo/mhwjuouB4TE3Y/kMP11HyfjSR0+mnR6XKOn9PD4bP/2Q=="
                transform="matrix(.48 0 0 .48 42.89 26.524)"
                overflow="visible"
              />
            </g>
          </g>
        </g>
        <g>
          <defs>
            <circle id="prefix__w" cx={50.8} cy={41.9} r={2.9} />
          </defs>
          <clipPath id="prefix__x">
            <use xlinkHref="#prefix__w" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__x)">
            <defs>
              <path id="prefix__y" d="M42.9 34h15.7v15.7H42.9z" />
            </defs>
            <clipPath id="prefix__z">
              <use xlinkHref="#prefix__y" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__z)">
              <image
                width={33}
                height={34}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG5AAACFAAAAzn/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAIwMBIgACEQEDEQH/ xACOAAADAQEBAAAAAAAAAAAAAAAABgcFBAEBAQAAAAAAAAAAAAAAAAAAAAAQAAIBAwIGAwAAAAAA AAAAAAMFBAACBgETMBESFRYHEDMUEQABAwEGAgkDBQAAAAAAAAABEQIDEgAhMRMEFHEiEEFRYYEy MwUVkUJyobFikiQSAQAAAAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAHWf8K2MztI/S+CmE86d 9GNvEO80ykhoxQDPrYDIAf/aAAgBAgABBQDg/wD/2gAIAQMAAQUA4P8A/9oACAEBAAEFAGTKEris /ZjEpI/sbIxExvMV73Ss+dEYOrBEJV4iDqNJPFP5tps5Fbra/wAZYx4Mt9MhySV0X9n9iY6Qcn4S p5bqf40p5H+l5tfvt5dWD7faa//aAAgBAgIGPwAf/9oACAEDAgY/AB//2gAIAQEBBj8Adq9dKIoW 3KcXOODWjEk2ez2yFmngXkklFcqA4pVQF7EPG1Uph1DUQsfHSMcQYy0rYQH/AD68BXadxuel5MTv u4Y/v0SaNriNLoTlNYtxkHqPI7V5fC3I0u4W52lq9to9Tp3mOaJwcx7ShBFs/JbR8Zv1U+vm7bK/ Gvrt7mCEO7nPgZHEWJ1MYkjINzrF0DQ0HADopQr8RUnd8pUv0sfe9KyqGWluqDQSWPAQSFMGkAA9 /Hpj0WmHmvkkINMbBi5xH6d91qcops/jkquyFq/st9WNpPL5Xep5MPu7u20mXs1U17DMyF/jm3J+ N1gqIoVVTxpvscrZUKE2VdWF+4zuevj1YXdH/9k="
                transform="matrix(.48 0 0 .48 42.89 33.724)"
                overflow="visible"
              />
            </g>
          </g>
        </g>
        <g>
          <defs>
            <circle id="prefix__A" cx={50.8} cy={49.4} r={2.9} />
          </defs>
          <clipPath id="prefix__B">
            <use xlinkHref="#prefix__A" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__B)">
            <defs>
              <path id="prefix__C" d="M42.9 41.5h15.7v15.7H42.9z" />
            </defs>
            <clipPath id="prefix__D">
              <use xlinkHref="#prefix__C" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__D)">
              <image
                width={33}
                height={33}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG3AAACEQAAAzr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAIwMBIgACEQEDEQH/ xACNAAEAAwEBAAAAAAAAAAAAAAAABQYHBAMBAQAAAAAAAAAAAAAAAAAAAAAQAAEEAgIDAQAAAAAA AAAAAAQBAwUGAAIUFRAwNRYRAAIAAgcECAUFAAAAAAAAAAECEQMAITESEwQUEEEFFVFxkSIycjM0 YYGhQiNiglODRBIBAAAAAAAAAAAAAAAAAAAAMP/aAAwDAQACEQMRAAAAtmZIg7LznPib+oopi7Zu SkUnTpaeOvPghdQDrB//2gAIAQIAAQUA9P8A/9oACAEDAAEFAPT/AP/aAAgBAQABBQCwWAOBDk7t YZDdiz2FhyqXtJJ7LtJ7yFhFCILUgN8ZUVdV/ZncWzMuM2GBltosqXlGzt84hHVXyqPHqqLquVes FzhfVx/i28TsBOq5EX8/P//aAAgBAgIGPwAf/9oACAEDAgY/AB//2gAIAQEBBj8A1OZi8xyVkSFI DTGAjvsUbzuoSMy2UlfbKyxMuH7wb57aCanEswWFgmTGmL81mFlPZROH8UVZWbchZM5e6kww8LAm pjuhUbIDfTMgn8WUY5aUvRhkh+140IkreIpCasDQEGBFYItBpqbwu8o1ELo95qNHfssvVwspxJJg KsczNcAgjuzGMxTX0qwpi1FSIEERFC6iEdmFhticlxrsDHD5lj3uq53uqg4tw2UZmaUBczKWtpii pWVd7Cw/DqoQRAiog2x2IzIycPRvzz7AQLUQ72P0p6CehpLP8/8AF5dj6rk0Lxu39Vqt3r6KuPmp LwuS4l4XcbmWHGP3Y/ch5qqSPQ8A9p7f+r9Oz//Z"
                transform="matrix(.48 0 0 .48 42.89 41.404)"
                overflow="visible"
              />
            </g>
          </g>
        </g>
        <g>
          <defs>
            <circle id="prefix__E" cx={50.8} cy={56.8} r={2.9} />
          </defs>
          <clipPath id="prefix__F">
            <use xlinkHref="#prefix__E" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__F)">
            <defs>
              <path id="prefix__G" d="M42.9 49h15.7v15.7H42.9z" />
            </defs>
            <clipPath id="prefix__H">
              <use xlinkHref="#prefix__G" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__H)">
              <image
                width={33}
                height={34}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG3AAACEAAAAzD/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAIwMBIgACEQEDEQH/ xACQAAADAQEBAAAAAAAAAAAAAAAABQcGAwQBAQAAAAAAAAAAAAAAAAAAAAAQAAAFAwQDAAAAAAAA AAAAAAIDBAUGABQVEDABBxETFhEAAQICBQgHCQAAAAAAAAAAARECEgMAIRMEFBAxQVGBIjQVcaHB MmIjM2GR0XKCklNkBRIBAAAAAAAAAAAAAAAAAAAAMP/aAAwDAQACEQMRAAAA2E24pBpuphzL+YoM N0107HCcbnsKeHulACetANQD/9oACAECAAEFANn/2gAIAQMAAQUA2f/aAAgBAQABBQB6e0TIjc+w H9aNNMZKmHFpyQ8mVOXQThICEp6ijkxxHIBiAP7VRbyMAy5BHnbhsVvTkQtMr0G4nsCLnqR6RyOr H1bhmzSU2t0hs7mN+MVX/9oACAECAgY/AB//2gAIAQMCBj8AH//aAAgBAQEGPwA3u+OqO7Klt70x 6LC340cLtMFxkGoS5QBeirXMcIl+VOikbL/MetRbNSYPc8FNlBcr8xt2vzvThWzm5zuqsJ9hO3Rk nsBNjczh5bTUhZ6h2vXYlPKYXJqok1sJo17CWvaQWuFRBFYIpiarPlOK7oXGW+E19yPqp/Sa8ITe pzgDqc9zmnaDS0e0OYRmcFFC+W0BStWSCExcmtE8HM7Rftrpzr+fLMyYgbe5TAS4hohbMA0oKinT ryslS2ubdGFbxeE3WNGcA6XHQOynDt4bA5zw34s+bryTY+VW0Z4TE2ieOz8pdemjbXBw/sYqzXQt jvdmukqHBopTl62CfVXFrXJ//9k="
                transform="matrix(.48 0 0 .48 42.89 48.604)"
                overflow="visible"
              />
            </g>
          </g>
        </g>
        <g>
          <defs>
            <circle id="prefix__I" cx={50.8} cy={64.3} r={2.9} />
          </defs>
          <clipPath id="prefix__J">
            <use xlinkHref="#prefix__I" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__J)">
            <defs>
              <path id="prefix__K" d="M42.9 56.4h15.7v15.7H42.9z" />
            </defs>
            <clipPath id="prefix__L">
              <use xlinkHref="#prefix__K" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__L)">
              <image
                width={33}
                height={34}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG3AAACDwAAAzT/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAIwMBIgACEQEDEQH/ xACQAAACAwADAAAAAAAAAAAAAAAABwQFBgECAwEBAAAAAAAAAAAAAAAAAAAAABAAAQMDBAMAAAAA AAAAAAAABAMFBgECFQAQMBQRNRYRAAECAgcFBgUFAAAAAAAAAAERAhIDACExQRMEFBBxIgUVUYGR MjM0YUJyI4NSYlMkRBIBAAAAAAAAAAAAAAAAAAAAMP/aAAwDAQACEQMRAAAA1i061BN3K48R/mFD Gc7VbFtUl4ShnhLXgGfbAEsA/9oACAECAAEFAOH/2gAIAQMAAQUA4f/aAAgBAQABBQB/fwmEJynM hPUHlMjGvik7sc1dTZzvcJCMCQXUgNcatK1tr9md1ZKkojIGB3uai3h1TOU11CMVPYouddtGIwW+ l4tv2lvSybdjvLX6/X//2gAIAQICBj8AH//aAAgBAwIGPwAf/9oACAEBAQY/ADmcyYpjlEiQCj5r xcOwC83b0BdBmDlJJKtlSOCGpPU858U+FBMl8xnucLprzNbYnlmxCjOX80DZOccgkzm1MnO/SR8r zdcbkqBpmQT9rKOOWlN7MMkP8XrRJLYjRJrYTQEFCKwRatNTEIekahIR7zUaOOyyKtLKcyZMaWuO ZmvANXC95e097XA0xkDmkIhrFC5rQFK7MLDdidFxoUK4fUseLdBxbqDm/LpZmZlrQ3MyWhXTGtqa 9gFZcBUR2IllexvC5mQlu/sZiwIEJYwkIXkeFpp6DPQ0ln+f+L6dkzVdHt4Y9XqPzaO/fQRdLxIz DqdeiXLD9uH6u+mX9DyD2nt/xft2f//Z"
                transform="matrix(.48 0 0 .48 42.89 56.284)"
                overflow="visible"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            fill="none"
            stroke="#1e1e1e"
            strokeWidth={1.75}
            strokeMiterlimit={10}
            d="M37.6.1v66.6"
          />
          <defs>
            <circle id="prefix__M" cx={37.6} cy={4.6} r={2.9} />
          </defs>
          <clipPath id="prefix__N">
            <use xlinkHref="#prefix__M" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__N)">
            <defs>
              <path id="prefix__O" d="M29.8-3.3h15.7v15.7H29.8z" />
            </defs>
            <clipPath id="prefix__P">
              <use xlinkHref="#prefix__O" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__P)">
              <image
                width={34}
                height={34}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG4AAACFAAAA0v/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAJgMBIgACEQEDEQH/ xACMAAADAQEBAQAAAAAAAAAAAAAABgcFAwQIAQEAAAAAAAAAAAAAAAAAAAAAEAABBAIDAQEAAAAA AAAAAAADAgQFBgAHARMUMDERAAIBAQQIAwYHAAAAAAAAAAECAxEAIRIEEDFBUWEiExSBQgXwcTKC oiOxUnIzYxUGEgEAAAAAAAAAAAAAAAAAAAAw/9oADAMBAAIRAxEAAAB6nXZHNppQOB9AE7DLwqdJ xkWj0m+PQb08ASKiA0gH/9oACAECAAEFAPj/AP/aAAgBAwABBQD4/wD/2gAIAQEAAQUAdu2zJtM7 JkDkRd7Qgld2KlyXNmS5eXAgkMorJyHjGs2dxrrYoSDskW88b2enGshnP7EiJxRrxWlzTJSVIVkd HO5N2mrN01bL75vcHq76L0eTP//aAAgBAgIGPwAf/9oACAEDAgY/AB//2gAIAQEBBj8AkzWakEUE QxSSNqA9tQ22Mfo6DKQg3SyKryt8rYkUcL/fZ5Bn2LSUxApGV5buVSlF4012jyfrKLC78q5xOWOu odRT8NfzA04AX6IPR4npCqCedVIvckhFbbcBWnEHdbBGuJtwtWRCo46M6gkIzGSwZUnaYZHjVfoY r4Wd2HLNDG6HeAOn+Km0c5AKqeYHbYlUVWI1KKDR67MR9t5cuitdeySRlh9YsmYyig57K1KLcDJG fiSu+6q+O+xRwVZSQykUII1gjRHk8nGZJpDcNijazHYBZv8APq1C8fNMBTFPUSYzwxgfLdok639d jwJgxdx3mrzdDk92LZY4+ngr5+pg1/x89sx2/YdOqU7HrdTzfv8Adfc/T46P/9k="
                transform="matrix(.48 0 0 .48 29.45 -3.716)"
                overflow="visible"
              />
            </g>
          </g>
          <defs>
            <circle id="prefix__Q" cx={37.6} cy={12} r={2.9} />
          </defs>
          <clipPath id="prefix__R">
            <use xlinkHref="#prefix__Q" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__R)">
            <defs>
              <path id="prefix__S" d="M29.8 4.2h15.7v15.7H29.8z" />
            </defs>
            <clipPath id="prefix__T">
              <use xlinkHref="#prefix__S" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__T)">
              <image
                width={34}
                height={34}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG0AAACDwAAAz//2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACYAJgMBIgACEQEDEQH/ xACJAAEBAAMBAQAAAAAAAAAAAAAGAAMFBwIIAQEAAAAAAAAAAAAAAAAAAAAAEAABBAMAAwEAAAAA AAAAAAADAgQFBgABBxAwMRMRAAIBAgQEAwYHAAAAAAAAAAECAxEEACFBEhAxUQVhcRPwgaEiUpKR MkJiIxQGEgEAAAAAAAAAAAAAAAAAAAAw/9oADAMBAAIRAxEAAAB5z/0DESrmuM+gIFGj0nSOVicx ZxBNYSDKDrOhFUf/2gAIAQIAAQUA9P8A/9oACAEDAAEFAPT/AP/aAAgBAQABBQA5wtgzPSzKWnoF o0uu9CbSJc6bLk/QY1kUtuYesbWJ04570QRB2WJdpaPp+WZPc39iRr1R75WzSzT54Zs3T90ippHU ss4aEZ0iL5/o1VTUkpz/2gAIAQICBj8AH//aAAgBAwIGPwAf/9oACAEBAQY/AHnncRwxgs7saBQN ThoezQhIxl/ZmFWbxWPkvvr5DG43KMv0GKPb8FB+OEs+5xi1uZDtSVT/AAux0+bNPDM+fC37NGaR 7RcTkHMkllRT5UJ/DG1AWPQYq6FR48LuVZKXtmFtXeoLlHdED9Qdj0r1FeeJHcUWWKN4zlmoGyv3 KcRzOAyA/Mp1xuiRUJHJeHfZCDsaW2VW0JWRCR7twxHe2S77y0BrEPzSRHMhf3LzA1z1pxjtLSMy zynaiL7ZAanEnYEdVnlTfJKK7WnDLJU5V21ULy5cCncp1tr6pMklqGMlamol9NJF3V+obsM0nep2 h/QghdXHm/okH7RiRf8APsjyhQJnO/1mA1PqgNSvQUrw/9k="
                transform="matrix(.48 0 0 .48 29.45 3.964)"
                overflow="visible"
              />
            </g>
          </g>
          <defs>
            <circle id="prefix__U" cx={37.6} cy={19.5} r={2.9} />
          </defs>
          <clipPath id="prefix__V">
            <use xlinkHref="#prefix__U" overflow="visible" />
          </clipPath>
          <g clipPath="url(#prefix__V)">
            <defs>
              <path id="prefix__W" d="M29.7 11.6h15.7v15.7H29.7z" />
            </defs>
            <clipPath id="prefix__X">
              <use xlinkHref="#prefix__W" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__X)">
              <image
                width={34}
                height={34}
                xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG3AAACFgAAA0f/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAJgMBIgACEQEDEQH/ xACLAAADAQEAAAAAAAAAAAAAAAAABgcFBAEBAAAAAAAAAAAAAAAAAAAAABAAAgEDBAIDAAAAAAAA AAAABAUDAAIGARIVBzATMTUWEQABAgMGBQEHBQAAAAAAAAABAgMREgQAIUFRIhMQMWEFFTLwcYGh QhQ0sYIjMzUSAQAAAAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAHWX9yidTQqcZfibhxr1ZkJt YJpGwUENVWATKSBpgH//2gAIAQIAAQUA8P8A/9oACAEDAAEFAPD/AP/aAAgBAQABBQBozDUhOM8e MZLHzyy/HewyoJN9mzstlfM0GGlJkKVliaUE4II687GHkiyIAu8IpxkPI1r8qx5LMCy7HNH68kac WekaI94X+eB4Csz9eyHifdj/ANbX/9oACAECAgY/AB//2gAIAQMCBj8AH//aAAgBAQEGPwBytrVy Mt4C9S1HkhAxJ9rrEUzhoKYeltkwXjep25RN+EB0sXE9xqQtUCpW85ql5Tar7N0vejv05IT90B/I 2OUVhPrGf1Y38rbkw24TTx0y84xysz25JO1SthahgXHL/kmHzsG2hFRwtF5MvTh3FhTi92iU2yFx Mdh1xsBEcoFSYZXWLqoSVDLa0QyTFsg9Yps3UIMCgxtFQ1Qhw71UqhI88whAxi242SfdrslDRCKy nJXTqPIxGpB6KgL+ll09S2pp5slK0KECCOAp6RBkBG8+QZGknFRzuuGNvAwP221tzfVPGfc98+rK PBvd8XJLf5Dc3vUP6dnXDOH6WEnhp43T+Tk+O5psj8L1K/zfxv29c+H/2Q=="
                transform="matrix(.48 0 0 .48 29.45 11.164)"
                overflow="visible"
              />
            </g>
          </g>
          <g>
            <defs>
              <circle id="prefix__Y" cx={37.6} cy={27} r={2.9} />
            </defs>
            <clipPath id="prefix__Z">
              <use xlinkHref="#prefix__Y" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__Z)">
              <defs>
                <path id="prefix__aa" d="M29.7 19.1h15.7v15.7H29.7z" />
              </defs>
              <clipPath id="prefix__ab">
                <use xlinkHref="#prefix__aa" overflow="visible" />
              </clipPath>
              <g clipPath="url(#prefix__ab)">
                <image
                  width={34}
                  height={34}
                  xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGvAAACBgAAAyv/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAJgMBIgACEQEDEQH/ xACIAAEBAQADAQAAAAAAAAAAAAAGAAcBAwUIAQEAAAAAAAAAAAAAAAAAAAAAEAABAwQCAwEAAAAA AAAAAAADAgQGAAEFBzAxEBITFREAAgECAwcDAwUAAAAAAAAAAQIDERIAQQQQITFRMhMUYXEFgZEj sSJSckMSAQAAAAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAHgDkGJFWZ9Z9AQWPA8TR8sExm7h DNoR5NQY0ehzUf/aAAgBAgABBQDh/9oACAEDAAEFAOH/2gAIAQEAAQUAOcLYOY2YW60bCkyVx3YL XJFrZeZLYiBrJdYDDtTeTPnEB2GNaJNiXSGr7PZNg8q/eJGu0HnsbNlmvXhmzcvnKIpZERqbfD9O tefD2r//2gAIAQICBj8AH//aAAgBAwIGPwAf/9oACAEBAQY/AHnncRwxgs7saBQMzhovh4FEYqPI nBLGo6ljBAFPWvthWM0bgEEo0S0amRtofscLpPk0XR6lqCORSTDIxPTv3ofckevAbIfhoXpFaJtU FPUSfxowHK26nqDkMWoKnkMVdCo9dmr1gkI1+kt0zTVJchmjQScw1j8eYriVmBAkiiZCcxbbUfVT iOWRQyA/uU8MEwIEBHSNnzshBsaXTKrZErIhI+lwxHrtEl+s0gIaMdUkXG1ebKd4Ge/Og2x6TSRm WeU2oi/qeQGZyw/wCyKJ5EueXfaZwwl5VtuUDhw2aingd7uPXxe93qXf71/Df/Km+uyTs+BXtm/s 97zK3L19/dZ/XdWmz//Z"
                  transform="matrix(.48 0 0 .48 29.45 18.844)"
                  overflow="visible"
                />
              </g>
            </g>
          </g>
          <g>
            <defs>
              <circle id="prefix__ac" cx={37.6} cy={34.4} r={2.9} />
            </defs>
            <clipPath id="prefix__ad">
              <use xlinkHref="#prefix__ac" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__ad)">
              <defs>
                <path id="prefix__ae" d="M29.7 26.6h15.7v15.7H29.7z" />
              </defs>
              <clipPath id="prefix__af">
                <use xlinkHref="#prefix__ae" overflow="visible" />
              </clipPath>
              <g clipPath="url(#prefix__af)">
                <image
                  width={34}
                  height={33}
                  xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG3AAACFgAAA0L/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAJgMBIgACEQEDEQH/ xACLAAADAQEAAAAAAAAAAAAAAAAABgcFBAEBAAAAAAAAAAAAAAAAAAAAABAAAgEEAgMBAQAAAAAA AAAABAUDAAECBhIHMBMVNRYRAAEDAgMFBgQHAAAAAAAAAAERAgMSBAAhExAxQVFxYSIyQgUV8IEU NKHRUoIjQzUSAQAAAAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAHWYdygdjQocpfichwL9Wkht YJoG0UENVWASaYBpgH//2gAIAQIAAQUA8P8A/9oACAEDAAEFAPD/AP/aAAgBAQABBQBmyEVBOd9d sJLbC/tfXOwyY5eeHDstnJMyHGlJkJWlDWoJwQR132MPJFsa8vIItw/xY1elY8mGhbjrdnq8kacW ekqQ50Z/PA/ArdPV68Pj89f/ADa//9oACAECAgY/AB//2gAIAQMCBj8AH//aAAgBAQEGPwCW+vHF sMQzQK5xOTWtHMn4TDm2shsbbc2OIo89rpPEvRBgEep3ajPOeQj8XYba+uHWhcQ1t0GgPYqDvhqA tHNF641KhppVWvdp3qvLEPpjXEQWzBI9m4GV65pxRu7qcacQVx4YWZlKbxs9QhMrtazdHbg5roSP jaGrypLm9MGVyU3EMb2ELuasZB7VbiO4b5CpwSWgOO9Bs9auXJRNNAxg4rHJGSenfwsAAv7dXW7j lWPNESf1cO354fb3MbopoyWvY4IQRsba2jCigyynwRsXNzvy449hQ/TaWnV5q1r1Otfe5LsZre16 dJq9w1Nfxf0/T/yJzpwKfaFXKr3RPnVlhn2Xid/m/bft7eez/9k="
                  transform="matrix(.48 0 0 .48 29.45 26.524)"
                  overflow="visible"
                />
              </g>
            </g>
          </g>
          <g>
            <defs>
              <circle id="prefix__ag" cx={37.6} cy={41.9} r={2.9} />
            </defs>
            <clipPath id="prefix__ah">
              <use xlinkHref="#prefix__ag" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__ah)">
              <defs>
                <path id="prefix__ai" d="M29.7 34h15.7v15.7H29.7z" />
              </defs>
              <clipPath id="prefix__aj">
                <use xlinkHref="#prefix__ai" overflow="visible" />
              </clipPath>
              <g clipPath="url(#prefix__aj)">
                <image
                  width={34}
                  height={34}
                  xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGqAAACAAAAAyH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAJgMBIgACEQEDEQH/ xACEAAEBAQEBAQAAAAAAAAAAAAAGAAcDBQgBAQAAAAAAAAAAAAAAAAAAAAAQAAEDBAMBAQAAAAAA AAAAAAIDBAYAAQUHEDAxExURAAIBAgMHBAIDAAAAAAAAAAECAxESACEEEDFRYRMUBUFxIjKBcpGh IxIBAAAAAAAAAAAAAAAAAAAAMP/aAAwDAQACEQMRAAAAeAoEJVWZcz6Ag8HfG0PLxQXuoim0I8ko NaLQ7qP/2gAIAQIAAQUA6f/aAAgBAwABBQDp/9oACAEBAAEFAF10WyOZ2WYqp7DkwHH9gMskpWy8 0pYwTNS5oLBbykJK8XgOwgMZNiHQNX8hyePd1f3EpnaD7Ajp5Jp5w2bLu1wilgiNTf5fq1rj5cf/ 2gAIAQICBj8AH//aAAgBAwIGPwAf/9oACAEBAQY/AHnncRwxgs7saBQPU4aHw0KtGtVOonBN3oGR AVoP2/gYDNLFIAalGiWh5G20/wB4XS+QQaPUtkj1rE7E0C1Oan3y57IvCwtSMqJtTa32JJsjYDhS 6h5HFqAseAxV0Kjns1OtWU9/pQumeWpv+TogkrvusffxzxMWUgPHEyEilwttqPyCMRSyKGjBFwOK 6dFjqPqNnnZCDY0umVW9CVkQsPxcML5LSKW1WjUiRBUmSGtfiBXNTn7V5bU0+nQyTSEKiKKkk4fw CyKJ5EueXO0zhhLwrbcoG7dsmp2PV6j3dp1erS7LuLv87+Nuda12SdPsbumb+n1e9rcv36vxs/TK tPXZ/9k="
                  transform="matrix(.48 0 0 .48 29.45 33.724)"
                  overflow="visible"
                />
              </g>
            </g>
          </g>
          <g>
            <defs>
              <circle id="prefix__ak" cx={37.6} cy={49.4} r={2.9} />
            </defs>
            <clipPath id="prefix__al">
              <use xlinkHref="#prefix__ak" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__al)">
              <defs>
                <path id="prefix__am" d="M29.7 41.5h15.7v15.7H29.7z" />
              </defs>
              <clipPath id="prefix__an">
                <use xlinkHref="#prefix__am" overflow="visible" />
              </clipPath>
              <g clipPath="url(#prefix__an)">
                <image
                  width={34}
                  height={33}
                  xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG3AAACFgAAA0r/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAJgMBIgACEQEDEQH/ xACLAAADAQEAAAAAAAAAAAAAAAAABgcFBAEBAAAAAAAAAAAAAAAAAAAAABAAAgEDBAIDAAAAAAAA AAAABAUDAAIGARIVBzARMRMUEQABAwICCQIEBwAAAAAAAAABEQIDEgQAExAhMUFRcTIUBSIV8JFy M2GBoeFCYkMSAQAAAAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAAHWZdqedjUncpfidBnr9Wkhu L53m2UANZRATqOBsAH//2gAIAQIAAQUA8P8A/9oACAEDAAEFAPD/AP/aAAgBAQABBQBkyFVhOc/d H325E/t1x3sQn9G+zZ2YzklYjjykyELSxtKDczkdddiwSR5GuLuCLcv7GNa/KseSzAsxxvnV88Ew 01J0x7kvTHV+iCs3+jdbw+7GPXF1/9oACAECAgY/AB//2gAIAQMCBj8AH//aAAgBAQEGPwCW+u3U wxBSmtzjua0byTh7LN/Y2pJDWx/dLVUF0m0H6UwCPJ3ajjPIR8i7DLXzha+KQoLtrQxzCT/oGo2n kPnjMqGWlVa+mnaq8MQ+MY85FuwSyM1gZr6kXijETmcZcQVx3YWZlOi/hMhE9kWW6hVyJJIw0E/S 5zOQw+R4Rk8Ub4zxAFB/VuI7hv8AEqQdmCSBUQmoINHm7lyUSzQMZtVY5IiTy9eA63aPcLZXW5Jp rB6oydmvcu/gFw+C4jdFNGaXxvCOafxB0NtbOMuUjMkPRG3e55+F3YPgQ1LZ0dBeOov6s0/2rFX7 aI8/2vLy9ffZ3c7Xfa7b108t+AntCqEX3VPzq1YFPYpWU9tXIRG9VWuviuj/2Q=="
                  transform="matrix(.48 0 0 .48 29.45 41.404)"
                  overflow="visible"
                />
              </g>
            </g>
          </g>
          <g>
            <defs>
              <circle id="prefix__ao" cx={37.6} cy={56.8} r={2.9} />
            </defs>
            <clipPath id="prefix__ap">
              <use xlinkHref="#prefix__ao" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__ap)">
              <defs>
                <path id="prefix__aq" d="M29.7 49h15.7v15.7H29.7z" />
              </defs>
              <clipPath id="prefix__ar">
                <use xlinkHref="#prefix__aq" overflow="visible" />
              </clipPath>
              <g clipPath="url(#prefix__ar)">
                <image
                  width={34}
                  height={34}
                  xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAG2AAACEgAAA03/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAJgMBIgACEQEDEQH/ xACOAAADAQEBAQAAAAAAAAAAAAAABQYHBAMIAQEAAAAAAAAAAAAAAAAAAAAAEAABBAIDAQEAAAAA AAAAAAAEAgMFBgAHMAEUEzERAAIBAgIHBQQLAAAAAAAAAAECAxESAAQQITFBURMjIlIUBRVxgbEy YZGhwUJicqKyMwYSAQAAAAAAAAAAAAAAAAAAADD/2gAMAwEAAhEDEQAAALrNuiJGtZBeB9AGdgrR adk5Qzp1j0vQdwAEVqAFIAf/2gAIAQIAAQUA4f/aAAgBAwABBQDh/9oACAEBAAEFACyxghpfZEqQ 8zbrKyut7D7IfzZsqpwtllx5TwZDHWCzb5GutiMuN2WML7DMm5sY/O/2KZcTRLvWlTQK0LQrI2MN lSk1cJNby9eb2M+X60r5eHP/2gAIAQICBj8AH//aAAgBAwIGPwAf/9oACAEBAQY/AJM3mpBFBCt0 jtsA+88ANuGXyoLk8upNjsqySsOLXhlHsA95xzE8wlLDVRyJF1/lkDDCZPzsJHf2Uzi9lbtwlXYA e8NQ3jfoy/lMbdOFedMBvkeoUH2L8cWRrc3DFZEK6M6gkIzGTsypO8wyPGq/sYr7sSO4os0Ubxni oFnxU4jnoCFOsHZgsiBSdoUatHnk5HTkmy6KfpSSMt/MYXMZUVz+UBMainVQ0ujJ471+rfXBR1Ku poykUII3EHQuUyMRllbbT5UWtLnO5RXbhv8APqxEbpRpgKM0tQ/NIr3wDSuzVok5/pdbOnzPEeNr aPn8Nq/Rfq+3CX+GtuF1/iLKV13cvtU4018MS8n0/l1W30/mXfi/v5/Ur3bt2j//2Q=="
                  transform="matrix(.48 0 0 .48 29.45 48.604)"
                  overflow="visible"
                />
              </g>
            </g>
          </g>
          <g>
            <defs>
              <circle id="prefix__as" cx={37.6} cy={64.3} r={2.9} />
            </defs>
            <clipPath id="prefix__at">
              <use xlinkHref="#prefix__as" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__at)">
              <defs>
                <path id="prefix__au" d="M29.7 56.4h15.7v15.7H29.7z" />
              </defs>
              <clipPath id="prefix__av">
                <use xlinkHref="#prefix__au" overflow="visible" />
              </clipPath>
              <g clipPath="url(#prefix__av)">
                <image
                  width={34}
                  height={34}
                  xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGwAAACEAAAA1X/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIACMAJgMBIgACEQEDEQH/ xACJAAADAQEAAAAAAAAAAAAAAAAABQYHBAEBAAAAAAAAAAAAAAAAAAAAABAAAQMEAgMAAAAAAAAA AAAABAMFBgABAgcwEjEUFREAAQMBBAcHBAMAAAAAAAAAARECAxIAMRMEECFBUWEUBXGBoSIychWx QlKyI1M0EgEAAAAAAAAAAAAAAAAAAAAw/9oADAMBAAIRAxEAAAC3zLsjTvqovmN+M6Beg1PJR4gO 4dl+DiPAi9LAcgH/2gAIAQIAAQUA4f/aAAgBAwABBQDh/9oACAEBAAEFAHBwEbRHjYLyarhJZDhn G9iL3W74dNmOmap6A6pGZDeUPag3lcjXWxUFE5G3F5BlvL8m4Vfy1IKYwSZRq76CsgsOrTQznvBd oyBaP1OfX7IfL9qK9fk1/9oACAECAgY/AB//2gAIAQMCBj8AH//aAAgBAQEGPwCTOZyQRwxhSTeT sa0bSbPbkHcjlbmtaA6Uje6QjUfanffbEHUsyXXo6Vzm7/S4kWbleulr45Cjc40BhYT/AGNaA0ji ETjsxKhhpVWvlpvVd1oOlsd/Dl2CWVoULK9UXYaWXe42oiCu3WWVlOjPwmQifJFmXUKuBJJGGgn2 uczsFnyPCMnijfGd4AoPi20c7ftOsG6xdSA47GhBo63O4JHLLl2sO8skjLv2FmvyyDP5ZTCuoSNP qjJ4pq49q2dDPG6KVhR8bwWuaeIOhuUyUZe4kVyFaI2/k92wfXZrsegAuGXcxDIErL6sSs8agvho h5n4zDpH+zH5lVd6OU89HgtpV+MpVmHifI4V2uhPNf6q+7VZlHJU1Gn46rBRGpVieav8l179H//Z"
                  transform="matrix(.48 0 0 .48 29.45 56.284)"
                  overflow="visible"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
